import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
/* eslint-disable react/no-danger,@typescript-eslint/naming-convention */
import { useContext, useId, } from 'preact/compat';
import { SuccessMessageStyles, Wrapper } from './styles';
function SuccessMessage({ visible, options }) {
    const { successMessage } = useContext(options);
    const id = useId();
    if (!successMessage) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Wrapper, { id: `success-wrapper-${id}`, style: { display: visible ? 'block' : 'none' }, dangerouslySetInnerHTML: { __html: successMessage } }), _jsx(SuccessMessageStyles, { affix: id })] }));
}
export default SuccessMessage;
